import MarkerClusterer from '@google/markerclusterer'
import GoogleMapsApiLoader, {GoogleMapsApiConfig} from '../../utils/google-maps-api-loader'

// Nando's chilli map marker
export const CHILLI_MARKER = {
  path: 'M12.0203011,7.335 L12.0203011,7.335 C11.9943011,7.052 11.9053011,6.794 11.7683011,6.569 L11.7733011,6.577 C11.6133011,6.336 11.4033011,6.142 11.1553011,6.006 L11.1463011,6.001 C11.0823011,5.952 11.0973011,5.918 11.0473011,5.869 C10.9483011,5.786 10.9643011,5.704 10.9643011,5.605 L10.9643011,5.605 C10.9643011,5.588 10.9153011,5.556 10.9153011,5.541 L10.8823011,5.524 L10.8653011,5.524 C10.9073011,5.342 11.0073011,5.187 11.1443011,5.077 L11.1463011,5.076 C11.1573011,5.065 11.1633011,5.049 11.1633011,5.033 C11.1633011,5.031 11.1633011,5.029 11.1633011,5.027 L11.1633011,5.027 C11.1633011,5.01 11.1463011,5.01 11.1303011,4.994 L10.9163011,4.879 L10.8823011,4.879 C10.7343011,4.912 10.6513011,4.994 10.5523011,5.143 C10.4633011,5.261 10.4083011,5.41 10.4043011,5.571 L10.4043011,5.572 C10.4043011,5.655 10.2393011,5.704 10.1403011,5.737 C10.0913011,5.754 10.0253011,5.77 9.9753011,5.786 L9.9583011,5.786 C9.9543011,5.786 9.9493011,5.785 9.9453011,5.785 C9.9203011,5.785 9.8963011,5.791 9.8753011,5.803 L9.8763011,5.803 C9.7573011,5.822 9.6573011,5.844 9.5593011,5.872 L9.5793011,5.867 L9.5463011,5.867 C9.4633011,5.9 9.3813011,5.931 9.3483011,5.95 C9.2993011,5.967 8.6893011,6.28 8.5903011,7.22 C8.5733011,7.418 8.6233011,7.632 8.6543011,7.847 C8.6543011,7.88 8.7033011,7.911 8.7033011,7.946 L8.6543011,7.946 C8.8023011,8.919 8.7693011,10.864 7.7473011,12.068 C7.7473011,12.068 7.5333011,12.332 7.7473011,12.563 C7.8173011,12.628 7.9083011,12.67 8.0093011,12.678 L8.0103011,12.678 C8.1913011,12.695 8.4583011,12.614 8.5373011,12.579 L8.5373011,12.579 C8.9203011,12.463 9.2543011,12.306 9.5593011,12.108 L9.5433011,12.117 C9.7243011,12.016 9.8813011,11.906 10.0253011,11.784 L10.0213011,11.788 C10.0383011,11.771 10.0703011,11.755 10.0853011,11.739 C10.1523011,11.691 10.2113011,11.642 10.2673011,11.59 L10.2663011,11.591 C10.4293011,11.449 10.5753011,11.298 10.7093011,11.136 L10.7143011,11.129 C10.7473011,11.096 10.7783011,11.046 10.8133011,11.014 C10.8623011,10.95 10.9123011,10.899 10.9283011,10.866 C11.0973011,10.655 11.2473011,10.417 11.3673011,10.162 L11.3763011,10.14 L11.5743011,9.711 C11.7553011,9.315 11.9043011,8.687 11.9203011,8.672 C11.9953011,8.387 12.0393011,8.061 12.0393011,7.724 C12.0393011,7.588 12.0323011,7.453 12.0183011,7.32 L12.0193011,7.337 L12.0203011,7.335 Z M19.0203011,7.582 C18.7563011,5.686 17.8683011,4.284 16.7123011,2.833 C15.3433011,1.135 13.4803011,0.541 11.3693011,0.245 C10.0493011,0.063 8.7303011,-0.035 7.4453011,0.097 C6.7033011,0.048 4.7903011,1.218 4.0983011,1.548 C0.4853011,3.394 -0.7986989,9.727 0.4853011,12.282 C1.6373011,14.59 2.4973011,17.46 4.0963011,19.817 C4.9703011,21.119 5.3823011,22.554 6.2233011,23.873 C6.9153011,24.945 7.7233011,26.462 8.1193011,27.732 C8.0203011,27.93 9.5703011,30.123 9.5703011,30.123 C9.8183011,29.348 11.2693011,27.452 11.4833011,26.677 C12.7533011,24.154 14.0063011,21.631 15.3423011,19.142 C16.0683011,17.774 17.7663011,14.342 17.9143011,14.064 C19.0863011,11.871 19.3343011,9.829 19.0213011,7.584 L19.0203011,7.582 Z M10.0203011,14.11 C6.7563011,14.11 4.1173011,12.016 4.1173011,8.751 C4.1173011,5.486 6.7553011,3.408 10.0053011,3.408 C13.2553011,3.408 15.3294046,6.179 15.3294046,8.753 C15.3463011,12.018 13.2683011,14.112 10.0203011,14.112 L10.0203011,14.11 Z M9.193,31.0361516 C7.989,31.0361516 7,31.2831516 7,31.5801516 C7,31.8771516 7.992,32.1241516 9.193,32.1241516 C10.394,32.1241516 11.384,31.8771516 11.384,31.5801516 C11.384,31.2831516 10.397,31.0361516 9.193,31.0361516 Z',
  fillColor: '#ed3a33',
  fillOpacity: 1,
  scale: 1.2,
  strokeWeight: 0,
  anchor: {x: 10, y: 33}, // x: half width, y: height
  labelOrigin: {x: 10, y: 40}, // shift by icon half width and height (+ padding)
}

export const USER_MARKER = {
  path: 'M36.8899 22.9798C36.8099 22.0948 36.5299 21.2948 36.1049 20.5898L36.1199 20.6148C35.6199 19.8648 34.9649 19.2598 34.1949 18.8348L34.1649 18.8198C33.9649 18.6648 34.0099 18.5648 33.8549 18.4098C33.5449 18.1548 33.5999 17.8948 33.5999 17.5898C33.5999 17.5398 33.4449 17.4348 33.4449 17.3898L33.3449 17.3398H33.2949C33.4249 16.7698 33.7349 16.2898 34.1649 15.9448L34.1699 15.9398C34.2049 15.9048 34.2249 15.8548 34.2249 15.8048C34.2249 15.7998 34.2249 15.7898 34.2249 15.7848C34.2249 15.7348 34.1749 15.7348 34.1249 15.6798L33.4549 15.3198H33.3499C32.8849 15.4248 32.6299 15.6798 32.3199 16.1398C32.0399 16.5098 31.8699 16.9698 31.8549 17.4748V17.4798C31.8549 17.7348 31.3399 17.8898 31.0349 17.9948C30.8799 18.0448 30.6749 18.0998 30.5199 18.1498H30.4699C30.4599 18.1498 30.4449 18.1498 30.4299 18.1498C30.3499 18.1498 30.2749 18.1698 30.2099 18.2048C29.8399 18.2648 29.5299 18.3348 29.2199 18.4198L29.2799 18.4048H29.1749C28.9199 18.5098 28.6599 18.6048 28.5599 18.6598C28.4049 18.7098 26.5049 19.6898 26.1949 22.6198C26.1449 23.2348 26.2949 23.9048 26.3949 24.5748C26.3949 24.6798 26.5499 24.7748 26.5499 24.8848H26.3949C26.8599 27.9198 26.7549 33.9848 23.5649 37.7398C23.5649 37.7398 22.8949 38.5598 23.5649 39.2848C23.7799 39.4848 24.0649 39.6198 24.3849 39.6448H24.3899C24.9549 39.6948 25.7849 39.4448 26.0349 39.3348C27.2299 38.9698 28.2699 38.4798 29.2199 37.8648L29.1699 37.8948C29.7349 37.5798 30.2249 37.2398 30.6749 36.8548L30.6599 36.8648C30.7099 36.8148 30.8149 36.7598 30.8599 36.7098C31.0699 36.5598 31.2549 36.4098 31.4299 36.2448L31.4249 36.2498C31.9299 35.8048 32.3899 35.3348 32.8049 34.8298L32.8199 34.8098C32.9199 34.7048 33.0199 34.5548 33.1299 34.4498C33.2849 34.2498 33.4349 34.0898 33.4899 33.9848C34.0149 33.3298 34.4849 32.5848 34.8599 31.7898L34.8899 31.7198L35.5049 30.3848C36.0699 29.1498 36.5349 27.1898 36.5849 27.1448C36.8199 26.2548 36.9549 25.2398 36.9549 24.1898C36.9549 23.7648 36.9349 23.3448 36.8899 22.9298L36.8949 22.9798H36.8899ZM59.4099 23.7498C58.5899 17.8348 55.8199 13.4648 52.2099 8.94483C47.9399 3.64983 42.1299 1.79983 35.5499 0.874834C31.4349 0.309834 27.3199 -0.000165612 23.3149 0.409834C20.9999 0.254834 15.0349 3.90483 12.8799 4.93483C1.61488 10.6898 -2.39012 30.4348 1.61488 38.4048C5.20488 45.6048 7.88488 54.5498 12.8749 61.8998C15.5999 65.9598 16.8849 70.4348 19.5099 74.5498C21.6699 77.8898 24.1849 82.6198 25.4249 86.5798C25.1149 87.1948 29.9499 94.0348 29.9499 94.0348C30.7199 91.6198 35.2449 85.7048 35.9149 83.2898C39.8749 75.4248 43.7799 67.5548 47.9449 59.7948C50.2099 55.5298 55.4999 44.8298 55.9649 43.9598C59.6199 37.1198 60.3949 30.7548 59.4149 23.7548L59.4099 23.7498ZM30.6199 44.1048C20.4449 44.1048 12.2149 37.5748 12.2149 27.3948C12.2149 17.2148 20.4399 10.7348 30.5749 10.7348C40.7099 10.7348 47.1749 19.3748 47.1749 27.3998C47.2249 37.5798 40.7499 44.1098 30.6199 44.1098V44.1048ZM30.1049 96.6098C26.3499 96.6098 23.2649 97.3798 23.2649 98.3048C23.2649 99.2298 26.3599 99.9998 30.1049 99.9998C33.8499 99.9998 36.9349 99.2298 36.9349 98.3048C36.9349 97.3798 33.8599 96.6098 30.1049 96.6098Z',
  fillColor: '#FF00B4',
  fillOpacity: 1,
  scale: 0.6,
  strokeWeight: 0,
  anchor: {x: 30, y: 100}, // x: half width, y: height
  labelOrigin: {x: 30, y: 110}, // shift by icon half width and height (+ padding)
}

export default {
  props: {
    useEmbedApi: {type: Boolean, default: false}, // use an iframe embedded map to help reduce API costs
    latitude: {type: Number, default: 0},
    longitude: {type: Number, default: 0},
    fullscreen: {type: Boolean, required: false},
    zoom: {type: Number, default: 11},
    markers: {type: Array, required: false, default: () => []},
    gestureHandling: {type: String, default() { return this.fullscreen ? 'greedy' : 'cooperative'}},
    zoomControl: {type: Boolean, default: false},
    fullscreenControl: {type: Boolean, default: false},
    mapTypeControl: {type: Boolean, default: false},
    scaleControl: {type: Boolean, default: false},
    streetViewControl: {type: Boolean, default: false},
    draggable: {type: Boolean, default: true},
    height: {type: String, default: '100%'},
    markerClustering: { type: Boolean },
  },

  data: function () {
    return {
      marker_clusterer: null,
      map_instance: null,
      map_ready: false,
      info_window: null,
      _markers: [],
      active_marker: null,
      apiKey: null,
    }
  },

  computed: {
    center() {
      return { lat: this.latitude, lng: this.longitude }
    },

    useSdkMap() {
      return this.useEmbedApi == false
    }
  },

  mounted() {
    if(this.useSdkMap) {
      GoogleMapsApiLoader.getApi()
        .then(() => this.init())
    }
    else {
      GoogleMapsApiLoader.getApiKey()
        .then(key => this.apiKey = key)
    }
  },

  watch: {
    latitude() {
      if(this.useSdkMap  && this.map_instance)
        this.map_instance.panTo(this.center)
    },

    longitude() {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.panTo(this.center)
    },

    zoom(zoom) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setZoom(zoom)
    },

    zoomControl(zoomControl) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({zoomControl})
    },

    fullscreenControl(fullscreenControl) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({fullscreenControl})
    },

    mapTypeControl(mapTypeControl) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({mapTypeControl})
    },

    scaleControl(scaleControl) {
      if(this.useSdkMap)
        this.map_instance.setOptions({scaleControl})
    },

    streetViewControl(streetViewControl) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({streetViewControl})
    },

    draggable(draggable) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({draggable})
    },

    gestureHandling(gestureHandling) {
      if(this.useSdkMap && this.map_instance)
        this.map_instance.setOptions({gestureHandling})
    },

    fullscreen() {
      if(this.useSdkMap) {
        if(this.fullscreen) {
          this._renderExternally()
        }
        else {
          this.$el.appendChild(this.$refs.map)
        }

        setTimeout(() => { // fucking google
          google.maps.event.trigger(this.map_instance, 'resize')
          this.map_instance.panTo(this.center)
          this.$emit('fullscreen', this.fullscreen)
        }, 0)
      }
    },

    markers(val) {
      if(this.useSdkMap) {
        this._destroyMarkers()
        this._processMarkers(val)
      }
    },
  },

  methods: {

    init() {
      this.map_instance = new google.maps.Map(this.$refs['map'], {
        center: this.center,
        zoom: this.zoom,
        gestureHandling: this.gestureHandling,
        zoomControl: this.zoomControl,
        mapTypeControl: this.mapTypeControl,
        scaleControl: this.scaleControl,
        streetViewControl: this.streetViewControl,
        draggable: this.draggable,
        rotateControl: this.rotateControl,
        fullscreenControl: this.fullscreenControl,
        styles: [{
          featureType: 'poi', // Shows more POI in the map
          stylers: [{visibility: 'on'}]
        }],
      })

      google.maps.event.addListener(this.map_instance, 'dragstart', e => this.$emit('drag-start', this.map_instance.getCenter(), this.map_instance))
      google.maps.event.addListener(this.map_instance, 'dragend', e => this.$emit('drag-end', this.map_instance.getCenter(), this.map_instance))
      google.maps.event.addListener(this.map_instance, 'zoom_changed', e => this.$emit('zoom-end', this.map_instance.getCenter(), this.map_instance))

      if(this.markerClustering) {
        this.marker_clusterer = new MarkerClusterer(this.map_instance, [], {
          minimumClusterSize: 2,
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
          maxZoom: 15,
        })
      }

      if(this.$scopedSlots['info-window']) {
        this.info_window = new google.maps.InfoWindow({
          content: this.$refs['info-window-content'],
        })
      }

      if(this.$slots['custom-controls']) {
        this.$slots['custom-controls'].forEach(node => {
          this.map_instance.controls[google.maps.ControlPosition.TOP_RIGHT].push(node.elm)
        })
      }

      this._processMarkers(this.markers)
      if(this.fullscreen) this._renderExternally()

      google.maps.event.addListenerOnce(this.map_instance, 'idle', () => this._onMapReady())
    },

    closeInfoWindow() {
      this.info_window.close()
    },

    // The shitty marker clusterer doesn't always recalculate clusters after programmatic zoom changes on the map, use this method to force a recalc
    forceClusterReCalc() {
      if(this.marker_clusterer) setTimeout(() => this.marker_clusterer.resetViewport(), 0)
    },

    _onMapReady() {
      this.map_ready = true
      this.$emit('ready', this.map_instance)
    },

    _processMarkers(markerList) {
      if(markerList && this.map_instance) {
        this.$data._markers = markerList.map(marker => {
          let animation = (marker.animation && google.maps.Animation[marker.animation]) || undefined
          return new google.maps.Marker(Object.assign({icon: CHILLI_MARKER}, marker, {animation}))
        })

        this.markerClustering
          ? this.marker_clusterer.addMarkers(this.$data._markers)
          : this.$data._markers.forEach(marker => marker.setMap(this.map_instance))

        // Add click listeners to new markers
        this.$data._markers.forEach(marker => {
          marker.addListener('click', e => {
            this.$emit('marker-click', marker)
            if(this.info_window) {
              this.active_marker = marker
              this.info_window.open(this.map_instance, this.active_marker)
            }
          })

          marker.addListener('dragstart', e => this.$emit('marker-dragstart', marker, e))
          
          marker.addListener('dragend', e => this.$emit('marker-dragend', marker, e))
        })
      }
    },

    _destroyMarkers() {
      if(this.marker_clusterer) this.marker_clusterer.clearMarkers()

      this.$data._markers.forEach(marker => {
        marker.setMap(null)
        google.maps.event.clearInstanceListeners(marker)
      })
    },

    /**
     * Renders the map as the last child of the app, instead of inside this component
     */
    _renderExternally() {
      document.querySelector('[data-app]').appendChild(this.$refs.map)
    },
  },

  beforeDestroy() {
    if(this.map_instance) {      
      this._destroyMarkers()
      this.map_instance.unbindAll()
      google.maps.event.clearInstanceListeners(this.map_instance)
      // If the map element is elsewhere in the DOM, manually clean it up
      if(this.fullscreen) this.$refs.map.parentNode.removeChild(this.$refs.map)
    }

    if(this.info_window) {
      this.info_window.unbindAll()
      google.maps.event.clearInstanceListeners(this.info_window)
    }
  }
}
